import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import submittedgradesapi from '../api/submittedgrades';
import loginapi from '../api/login';

import { APISERVERURL } from '../APIServerURL';
import { useState } from "react";
function SubmittedFormFillupReport({accessToken,setAccessToken,setRefreshFailed ,sessions=[] }) {
  const navigate = useNavigate();
 
  // const session='2025-DECEMBER';
   const [session,setSession]=useState("");
  const handleGoBack = () => {
    navigate(`/formfillupDetails`); 
  };

const [isDownloading,setIsDownloading]=useState(false);


   const sessionChanged = async (e) => {
    const tsession = e.target.value;
    setSession(tsession);
  
  };

  
    function downloadFile(fname)
      {
        fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
          response.blob().then((blob) => {
           
              // Creating new object of PDF file
              const fileURL =
                  window.URL.createObjectURL(blob);
                   
              // Setting various property values
              let alink = document.createElement("a");
              alink.href = fileURL;
              alink.download = fname;
              alink.click();
              //setIsloading(false);
          });
        });
      }
  
  async function handleDownloadCSV(e)
      {
        e.preventDefault();
        setIsDownloading(true);
        try{
          const response= await submittedgradesapi.post('/getSubmittedFormfillupCSV',{ session},{headers:{'Authorization':`Bearer ${accessToken}`}});    
          alert(response.data);
          downloadFile(response.data);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);
            
            const nat=x['data']['accessToken'];
            setAccessToken(nat);
            try{       
              const response= await submittedgradesapi.post('/getSubmittedFormfillupCSV',{session},{headers:{'Authorization':`Bearer ${nat}`}});    
              downloadFile(response.data);
             }
             catch(err)
             {
              if( err.response.status===403)
                {
                  navigate(`/accessdenied`); 
                }
              alert('unusual error newposts.js');
             }
          }
          catch(err)
          {
            alert('failed');
          }
  
        }
        finally
        {
          setIsDownloading(false);
        }
      }
  
  


  return (
     <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> SUBMITTED FORM FILLUP CSV REPORT</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

    

      <div className="flex flex-col justify-center gap-4 mt-4">
        
         <div className="flex flex-col items-center text-center mb-4">
            <p className="text-center">Select Exam session</p>
            <select
        value={session}
        onChange={(e) => sessionChanged(e)}
        className="p-2 rounded border w-full"
      >
        <option value="">-- Choose a session --</option>
        {sessions.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>
          </div>

        
        <button
  className="underline text-blue-600 hover:text-blue-800 cursor-pointer text-xs flex items-center gap-2 disabled:text-gray-400"
  onClick={handleDownloadCSV}
  disabled={isDownloading}
>
  {isDownloading ? (
    <>
      <svg
        className="animate-spin h-4 w-4 text-blue-600"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v8H4z"
        />
      </svg>
      Please wait...
    </>
  ) : (
    "DOWNLOAD CSV"
  )}
</button>

      </div>
      </div>
    </main>
  );
}

export default SubmittedFormFillupReport;
